import { useEffect, useState } from "react";
type User = { id: string; email?: string | null; user_metadata?: Record<string, unknown> } | null;
type Session = { user?: User | null } | null;
import { registrarAcesso } from "@/lib/acesso";
import { logAuthCliente } from "@/lib/auth-log";
import { obterClienteDados } from "@/lib/obter-dados";
import devConfig from "@/../config/dev.config.json";

export function useAuth() {
  const [session, setSession] = useState<Session | null>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let unsub = () => {};
    (async () => {
      const banco = await obterClienteDados();
      const { data: sub } = (banco as any).auth.onAuthStateChange((event: string, s: any) => {
        /*
        logAuthCliente("Evento de autenticação recebido", {
          evento: event,
          possuiSessao: !!s,
          usuarioId: s?.user?.id ?? null,
          email: s?.user?.email ?? null,
          nivel: s?.user?.user_metadata?.["nivel"] ?? null,
        });
        */
        setSession(s);
        setLoading(false);
        if ((event === "SIGNED_IN" || event === "INITIAL_SESSION") && s?.user) {
          void registrarAcesso(s.user.id, s.user.email ?? "");
        }
      });
      unsub = () => sub.subscription.unsubscribe();

      const { data } = await (banco as any).auth.getSession();
      if (devConfig?.logarSessao === true) {
        logAuthCliente("Leitura inicial da sessão concluída", {
          possuiSessao: !!data.session,
          usuarioId: data.session?.user?.id ?? null,
          nivel: data.session?.user?.user_metadata?.["nivel"] ?? null,
        });
      }
      setSession(data.session);
      setLoading(false);
      if (data.session?.user) {
        void registrarAcesso(data.session.user.id, data.session.user.email ?? "");
      }
    })();
    return () => unsub();
  }, []);

  return { session, user: (session?.user ?? null) as User | null, loading };
}

export function useIsAdmin(userId?: string) {
  const [isAdmin, setIsAdmin] = useState(false);

  useEffect(() => {
    if (!userId) {
      setIsAdmin(false);
      return;
    }
    let active = true;
    (async () => {
      try {
        const banco = await obterClienteDados();

        const res = await (banco as any)
          .from("user_roles")
          .select("role")
          .eq("user_id", userId)
          .eq("role", "admin")
          .maybeSingle();
        if (active) setIsAdmin(!!res.data);
      } catch {
        if (active) setIsAdmin(false);
      }
    })();
    return () => {
      active = false;
    };
  }, [userId]);

  return isAdmin;
}
